import { useCallback } from 'react';
import axios from 'axios';
import { useAppContext } from '../Store/Store';

interface NavigationEvent {
  from_screen?: string;
  to_screen: string;
  navigation_type: 'forward' | 'back' | 'skip' | 'direct' | 'repeat';
  screen_index: number;
  total_screens: number;
}

export const useNavigationTracking = () => {
  const { product, backendBaseUrl, userEmail } = useAppContext();

  const getSessionId = useCallback(() => {
    let sessionId = sessionStorage.getItem('navigation_session_id');
    if (!sessionId) {
      sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      sessionStorage.setItem('navigation_session_id', sessionId);
    }
    return sessionId;
  }, []);

  const trackNavigation = useCallback(
    async (event: NavigationEvent) => {
      if (!product?.code) return;
      if (!event?.to_screen) return;

      try {
        await axios.post(`${backendBaseUrl}/track-navigation/`, {
          product_code: product.code,
          session_id: getSessionId(),
          user_email: userEmail || undefined,
          ...event,
        });
      } catch (error) {
        console.error('Failed to track navigation:', error);
      }
    },
    [product, backendBaseUrl, userEmail, getSessionId]
  );

  return { trackNavigation };
};
